import {makeStyles, Theme, createStyles} from "@material-ui/core";
import {green, red} from "@material-ui/core/colors";

const useClasses = makeStyles((theme: Theme) => createStyles({
    root: {
        width: "100%",
    },
    online: {
        color: green["A400"]
    },
    offline: {
        color: red["A400"]
    }
}));

export default useClasses;
